// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_spot_market_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_spot_market_model.proto.
 */
export const file_bffuser_v1_bidding_spot_market_model: GenFile = /*@__PURE__*/
  fileDesc("CipiZmZ1c2VyL3YxL2JpZGRpbmdfc3BvdF9tYXJrZXRfbW9kZWwucHJvdG8SCmJmZnVzZXIudjEiawoaQmlkZGluZ1Nwb3RNYXJrZXRBcmVhUHJpY2USKAoJYXJlYV9jb2RlGAEgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGUSIwoFcHJpY2UYAiABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsItkBChtCaWRkaW5nU3BvdE1hcmtldEtvbWFQcmljZXMSKAoNZGVsaXZlcnlfZGF0ZRgBIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSEQoJdGltZV9jb2RlGAIgASgFEi8KDHN5c3RlbV9wcmljZRgDIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWxIAIgBARI7CgthcmVhX3ByaWNlcxgEIAMoCzImLmJmZnVzZXIudjEuQmlkZGluZ1Nwb3RNYXJrZXRBcmVhUHJpY2VCDwoNX3N5c3RlbV9wcmljZUJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_google_type_date, file_google_type_decimal]);

/**
 * スポット市場の 1 エリアの約定価格 (BFF mirror)。
 * backend `internalapi.v1.SpotMarketAreaPrice` と 1:1 (field 番号も一致)。
 *
 * @generated from message bffuser.v1.BiddingSpotMarketAreaPrice
 */
export type BiddingSpotMarketAreaPrice = Message<"bffuser.v1.BiddingSpotMarketAreaPrice"> & {
  /**
   * エリア。 JEPX スポットの取引対象 9 エリアのみ (沖縄は載らない)。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * エリアプライス (円/kWh)。 精度保全のため Decimal。
   *
   * @generated from field: google.type.Decimal price = 2;
   */
  price?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingSpotMarketAreaPrice.
 * Use `create(BiddingSpotMarketAreaPriceSchema)` to create a new message.
 */
export const BiddingSpotMarketAreaPriceSchema: GenMessage<BiddingSpotMarketAreaPrice> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_market_model, 0);

/**
 * スポット市場の 1 受渡日 × 1 コマの約定価格 (BFF mirror)。
 * backend `internalapi.v1.SpotMarketKomaPrices` と 1:1 (field 番号も一致)。
 *
 * @generated from message bffuser.v1.BiddingSpotMarketKomaPrices
 */
export type BiddingSpotMarketKomaPrices = Message<"bffuser.v1.BiddingSpotMarketKomaPrices"> & {
  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 2;
   */
  timeCode: number;

  /**
   * システムプライス (円/kWh)。 eSLJ が価格を返していない時は unset。
   *
   * @generated from field: optional google.type.Decimal system_price = 3;
   */
  systemPrice?: Decimal;

  /**
   * エリアプライス。 eSLJ が価格を返したエリアだけを載せる。
   *
   * @generated from field: repeated bffuser.v1.BiddingSpotMarketAreaPrice area_prices = 4;
   */
  areaPrices: BiddingSpotMarketAreaPrice[];
};

/**
 * Describes the message bffuser.v1.BiddingSpotMarketKomaPrices.
 * Use `create(BiddingSpotMarketKomaPricesSchema)` to create a new message.
 */
export const BiddingSpotMarketKomaPricesSchema: GenMessage<BiddingSpotMarketKomaPrices> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_market_model, 1);

